import React from 'react';

export const MailIcon = ({ color } : {color: string}) => {
    return <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3.46729" y="5.41675" width="20.804" height="15.1667" rx="2" stroke={color} strokeOpacity="0.9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.46729 7.58325L13.8693 14.0833L24.2712 7.58325" stroke={color} strokeOpacity="0.9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>;
};